import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL     = 'https://lsiiihodiiwryfsgxcjl.supabase.co';
const SUPABASE_ANON_KEY = 'sb_publishable_rkO8wm9jDqw_FcK_hzK0Cg_jLSKloiZ';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
